import { iife, Maybe } from '@crocodille/common';
import { useRouter } from 'next/router';
import React from 'react';
import { useTranslation } from 'react-i18next';

import onlyPickupEnImage from '../../../../public/only-delivery/only_delivery-en.png';
import onlyPickupMobileEnImage from '../../../../public/only-delivery/only_delivery-mobile-en.png';
import onlyPickupMobileImage from '../../../../public/only-delivery/only_delivery-mobile.png';
import onlyPickupImage from '../../../../public/only-delivery/only_delivery.png';
import { useMedia } from '../../../hooks/use-media';
import Image from '../../elements/image/image';
import styles from './product-only-delivery.module.scss';

export interface ProductOnlyDeliveryProps {
  readonly isOnlyDelivery?: Maybe<boolean>;
  readonly forceMobile?: boolean;
}

/**
 * A card displaying product information in product listing.
 */
const ProductOnlyDelivery: React.FC<
  React.PropsWithChildren<ProductOnlyDeliveryProps>
> = ({ isOnlyDelivery = false, forceMobile = false }) => {
  const { t } = useTranslation();
  const { locale } = useRouter();

  const isMobile = useMedia('layout-with-drawer', false);

  const onlyPickupImg = iife(() => {
    if (isMobile || forceMobile) {
      if (locale === 'cs') {
        return onlyPickupMobileImage;
      } else {
        return onlyPickupMobileEnImage;
      }
    } else {
      if (locale === 'cs') {
        return onlyPickupImage;
      } else {
        return onlyPickupEnImage;
      }
    }
  });

  return isOnlyDelivery ? (
    <div className={styles.imageContainer}>
      <Image
        className={styles.image}
        src={onlyPickupImg}
        alt={t('cart.only_delivery')}
        layout="fill"
      ></Image>
    </div>
  ) : null;
};

export default ProductOnlyDelivery;
